import React from "react";

import { SLIDESHOW } from "../../data/content";

const Arrow = ({ isNext }) => (
  <svg
    viewBox={"0 0 24 24"}
    aria-hidden={"true"}
  >
    <path d={isNext ? "M9 4l8 8-8 8" : "M15 4l-8 8 8 8"} />
  </svg>
);

//Full-width photo slideshow with arrows, dots and swiping (Wix only had a "next" arrow)
const Slideshow = () => {
  const [current, setCurrent] = React.useState(0);
  const [loadUpTo, setLoadUpTo] = React.useState(1);
  const touchStart = React.useRef(null);
  const count = SLIDESHOW.length;

  //Photos load as the visitor reaches them (plus the next one, so it's ready). Going back from the first photo loads the rest
  React.useEffect(() => {
    setLoadUpTo((n) => Math.max(n, current + 1, current === count - 1 ? count : 0));
  }, [current, count]);

  const go = (step) => setCurrent((c) => (c + step + count) % count);

  const onTouchStart = (e) => {
    touchStart.current = e.touches[0].clientX;
  };
  const onTouchEnd = (e) => {
    if (touchStart.current === null) {
      return;
    }
    const dx = e.changedTouches[0].clientX - touchStart.current;
    touchStart.current = null;
    if (Math.abs(dx) > 50) {
      go(dx < 0 ? 1 : -1);
    }
  };

  return (
    <section
      className={"slideshow"}
      aria-roledescription={"carousel"}
      aria-label={"Beechwood Gardens photos"}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      onKeyDown={(e) => {
        if (e.key === "ArrowRight") {
          go(1);
        }
        else if (e.key === "ArrowLeft") {
          go(-1);
        }
      }}
    >
      <ul
        className={"slideshow-track"}
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {SLIDESHOW.map((slide, i) => (
          <li
            key={slide.src}
            className={"slideshow-slide"}
            aria-roledescription={"slide"}
            aria-label={`${i + 1} of ${count}`}
            aria-hidden={i !== current}
          >
            {i <= loadUpTo ? (
              <img
                src={slide.src}
                alt={slide.alt}
                width={slide.width}
                height={slide.height}
              />
            ) : null}
          </li>
        ))}
      </ul>

      <button
        type={"button"}
        className={"slideshow-arrow is-prev"}
        aria-label={"Previous photo"}
        onClick={() => go(-1)}
      >
        <Arrow />
      </button>
      <button
        type={"button"}
        className={"slideshow-arrow is-next"}
        aria-label={"Next photo"}
        onClick={() => go(1)}
      >
        <Arrow isNext />
      </button>

      <div className={"slideshow-dots"}>
        {SLIDESHOW.map((slide, i) => (
          <button
            key={slide.src}
            type={"button"}
            className={`slideshow-dot ${i === current ? "is-current" : ""}`}
            aria-label={`Show photo ${i + 1}`}
            aria-current={i === current ? "true" : undefined}
            onClick={() => setCurrent(i)}
          />
        ))}
      </div>
    </section>
  );
};

export default Slideshow;
